/* 
Model defined for Maintaining Permission Requests/Responses. It can also be used for transferring model
*/

export class PermissionsModel {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    mobile: string;
    photo: string;
    roles: Role[];
    permissions: Permissions[];
}

export class Role {
    id: string;
    name: string;
    partnerId: string;
}
export class Permissions {
    id: string;
    name: string;
    description: string;
    groupName: string;
    partnerId: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/permissions/permissionsModel.ts